import { DEFAULT_S3_BASE } from '../constants';
import { getVariableOrNull, getEnvFromUrl } from './env';

/**
 * Build link to s3 storage based on agency, env and path to the file.
 *
 * @param {{
 *  agency: string;
 *  path: string;
 * }} params
 * @returns {string} S3 url.
 */
export const s3Url = ({ agency = 'compulse360', path }) => {
  const env = getEnvFromUrl(window.location.hostname) === 'production' ? 'prod' : 'stg';
  const base = getVariableOrNull('VUE_APP_BASE_WL_S3') || DEFAULT_S3_BASE;
  return `${base}/${agency}/${env}/${path}`;
};
